module.exports = __webpack_public_path__ + "img/image5.f35018d5.png";